import config from '../../config/app_config';

export const getMetricsAPIURL = (client, entityType='campaign', metricType, slug) => {
  if(entityType === 'campaign') {
    return `${config.API_ROOT_URL}/v1/offer/${client}/metrics/${slug}/?metric_type=${metricType}`;
  } else {
    return `${config.API_ROOT_URL}/v1/offer/${client}/prm-metrics/${slug}/?metric_type=${metricType}`;
  }
};
